import { select } from 'd3-selection';
import { DateTime } from 'luxon';


function _cloneTemplate(container) {
  try {
    const item = this.node().content.cloneNode(true);
    container.node().appendChild(item);
    return select(Array.from(container.node().children).at(-1));
  }
  catch (e) {
    debugger;
  }
}



const timeZone = "Europe/London";

function createDateTimePrinter(tokens) {
  return function(timestamp) {
    return DateTime
      .fromMillis(timestamp)
      .setZone(timeZone)
      .setLocale('en-GB')
      .toFormat(tokens);
  }
}


export { _cloneTemplate, timeZone, createDateTimePrinter };
